/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProvidersEnum } from './cloudProvidersEnum';


export interface RansomwareActivationSpec { 
    /**
     * Org id
     */
    org_id: string;
    provider: CloudProvidersEnum;
    /**
     * Cloud Provider Region ID
     */
    region: string;
    /**
     * Carbon Black PoP ID
     */
    cb_pop_id: string;
    /**
     * Requester Email Address
     */
    requester_email: string;
    /**
     * Requester first name
     */
    requester_first_name?: string;
    /**
     * Requester last name
     */
    requester_last_name?: string;
}
export namespace RansomwareActivationSpec {
}


